import { render, staticRenderFns } from "./PickupAcknowledgement.vue?vue&type=template&id=382bd157&scoped=true"
import script from "./PickupAcknowledgement.vue?vue&type=script&lang=js"
export * from "./PickupAcknowledgement.vue?vue&type=script&lang=js"
import style0 from "./PickupAcknowledgement.vue?vue&type=style&index=0&id=382bd157&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382bd157",
  null
  
)

export default component.exports